import { supabase } from "./supabase.js";

// Thin data layer around the existing schema: matches, tips, results.
// All filtering uses Supabase query builders (parameterized) — never string
// concatenation — so there is no SQL-injection surface from user input.

export async function fetchAll() {
  const [mRes, tRes, rRes] = await Promise.all([
    supabase.from("matches").select("*").order("kickoff", { ascending: true }),
    supabase.from("tips").select("*"),
    supabase.from("results").select("*"),
  ]);

  const err = mRes.error || tRes.error || rRes.error;
  if (err) throw err;

  return {
    matches: mRes.data ?? [],
    tips: tRes.data ?? [],
    results: rRes.data ?? [],
  };
}

export async function insertTip({ playerName, matchId, homeGoals, awayGoals }) {
  const { error } = await supabase.from("tips").insert({
    player_name: playerName,
    match_id: matchId,
    home_goals: homeGoals,
    away_goals: awayGoals,
  });
  return error;
}
